import InputField from 'components/molecules/input-field'
import LoaderButton from 'components/molecules/loader-button'
import GenericModal from 'components/organisms/generic-modal'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'reactstrap'
import * as Yup from 'yup'


const propTypes = {
  modalProps: PropTypes.shape({
    isOpen : PropTypes.bool,
    toggle : PropTypes.func
  }).isRequired,
  selectedCurrentInventory: PropTypes.shape({
    inventory_sku   : PropTypes.string,
    stored_quantity : PropTypes.number
  }),
  onAddBorrowedInventory: PropTypes.func.isRequired
}

/**
 * Confirm modal-based form for inputing borrow quantity in Internal Request
 * @param {object} modalProps - Modal wrapper props
 * @param {func} onAddBorrowedInventory - Handler to add borrowed Inventory
 * @param {object} selectedCurrentInventory - Selected current Inventory
 */
const InternalRequestBorrowConfirmModalForm = ({
  modalProps,
  onAddBorrowedInventory,
  selectedCurrentInventory
}) => {

  /**
   * Internal Request only needs to validate IQ/stored quantity because the product
   * can be borrowed as long as the physical item is available in store.
   * @param {object} inventory - Selected current Inventory
   */
  const findMaxBorrowQuantity = (inventory) => Number(inventory?.stored_quantity || inventory?.quantity || 0)

  /** Generate validation schema for the form */
  const validationSchema = () => Yup.object().shape({
    quantity: Yup.number()
      .min(1, 'Quantity shouldn\'t be less than 0.')
      .max(findMaxBorrowQuantity(selectedCurrentInventory), 'Cannot borrow product more than inventory quantity')
      .required('Required')
  })

  return (
    <GenericModal
      { ...modalProps }
      title={ 'Borrow Inventory Product' }
    >
      <Formik
        enableReinitialize={ true }
        initialValues={
          {
            quantity: 1
          }
        }
        validationSchema={ validationSchema }
        onSubmit={ onAddBorrowedInventory }
      >
        {
          (formikBag) => (
            <>
              <h2>{ `How many pcs. of ${selectedCurrentInventory?.inventory_sku} you want to borrow?` }</h2>

              <Form>
                <InputField
                  type='number'
                  name='quantity'
                />

                <div className='d-flex justify-content-center my-3'>
                  <LoaderButton
                    color='primary'
                    type='submit'
                    onSubmit={ formikBag.submitForm }
                    disabled={ formikBag.isSubmitting }
                    isLoading={ formikBag.isSubmitting }
                    text='Borrow Product'
                  />
                  <Button
                    color='danger'
                    onClick={ modalProps.toggle }
                  >
                   Cancel
                  </Button>
                </div>

              </Form>
            </>
          )
        }
      </Formik>
    </GenericModal>
  )
}

InternalRequestBorrowConfirmModalForm.propTypes = propTypes

export default InternalRequestBorrowConfirmModalForm
